module.exports = __webpack_public_path__ + "img/portis.f239eb8f.svg";